import firebase from "config/firebase";
import { toast } from "react-toastify";

export const createContractRequest =
  (obj, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const storageRef = firebase.storage().ref();
      const imageRef = storageRef.child(`images/${obj.image.name}`);
      await imageRef.put(obj.image);
      const imageURL = await imageRef.getDownloadURL();
      const formData = {
        state: obj.state,
        country: obj.country,
        school: obj.school,
        email: obj.email,
        type: obj.type,
        imageURL: imageURL,
        status: "pending",
        createdAT: firebase.firestore.FieldValue.serverTimestamp(),
      };
      const docRef = await firebase
        .firestore()
        .collection("request_School_Contracts")
        .add(formData);
      const notificationData = {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        type: "IP Contract",
        notifyID: docRef.id,
        image: imageURL,
        status: false,
      };
      await firebase
        .firestore()
        .collection("admin_notifiaction")
        .add(notificationData);
      toast.success("Request sent successfully!");
      onComplete();
    } catch (error) {
      toast.error(
        error.message ||
          "An error occurred while submitting the form. Please try again later."
      );
    }
  };

export const isExitContract =
  (obj, onComplete = () => {}) =>
  async () => {
    try {
      const contractsQuery = await firebase
        .firestore()
        .collection("schoolContracts")
        .where("state", "==", obj.state)
        .where("country", "==", obj.country)
        .where("school", "==", obj.school)
        .where("type", "==", obj.type)
        .get();

      const contractRequestsQuery = await firebase
        .firestore()
        .collection("request_School_Contracts")
        .where("state", "==", obj.state)
        .where("country", "==", obj.country)
        .where("school", "==", obj.school)
        .where("type", "==", obj.type)
        .get();
      const userEmailQuery = await firebase
        .firestore()
        .collection("users")
        .where("email", "==", obj.email)
        .get();

      const hasContracts = !contractsQuery.empty;
      const hasContractRequests = !contractRequestsQuery.empty;
      const userEmail = !userEmailQuery.empty;

      if (hasContracts) {
        toast.warning("This school already has a contract");
        onComplete();
      } else if (userEmail) {
        toast.warning(
          "This email user already exit please use different email"
        );
        onComplete();
      } else if (hasContractRequests) {
        toast.warning("This school already has a contract request");
        onComplete();
      } else {
        onComplete("success");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      onComplete();
    }
  };

export const fetchContractByID = (id) => async (dispatch) => {
  dispatch(IsLoader(true));
  await firebase
    .firestore()
    .collection("schoolContracts")
    .doc(id)
    .onSnapshot((doc) => {
      if (doc.exists) {
        const contractData = { id: doc.id, ...doc.data() };
        dispatch({ type: "GETContractByID", payload: contractData });
        dispatch(IsLoader(false));
      } else {
      }
    });
};

export const SubmitContract = (ID, payload) => async (dispatch) => {
  try {
    await firebase
      .firestore()
      .collection("schoolContracts")
      .doc(ID)
      .update(payload);
    toast.success(" Submit Successfully");
  } catch (error) {
    toast.error("Error Submiting");
  }
};

export const findContract =
  (payload, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("schoolContracts")
      .where("state", "==", payload.state)
      .where("country", "==", payload.country)
      .where("school", "==", payload.school)
      .where("type", "==", payload.type)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          toast.info("No contract found");
        } else {
          querySnapshot.forEach((doc) => {
            const contractData = {
              id: doc.id,
              status: doc.data().status,
              ...doc.data(),
            };
            if (contractData.status === "approved") {
              dispatch({ type: "FIND_CONTRACT", payload: contractData });
              onComplete(doc.id);
            } else {
              toast.info("No contract found");
            }
          });
        }
      })
      .catch((error) => {
        toast.error("Error finding contract");
        console.error(error);
      });
  };

export const getMatchSchoolContract = (payload) => async (dispatch) => {
  try {
    firebase
      .firestore()
      .collection("users")
      .where("state", "==", payload.state)
      .where("county", "==", payload.county)
      .where("instituteName", "==", payload.school)
      .where("ip_contract", "==", true)
      .where("role", "==", "school-admin")
      .get()
      .then((query) => {
        if (query.docs.length > 0) {
          dispatch({
            type: "EXIST-CONTRACT-CID",
            payload: query.docs[0].id,
          });
        } else {
          dispatch({
            type: "EXIST-CONTRACT-CID",
            payload: null,
          });
        }
      })
      .catch((error) => {
        toast.error("Error finding contract");
        console.error(error);
      });
  } catch (error) {
    console.error(error);
  }
};

export const addSchoolContract =
  (obj, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .doc(obj.uid)
      .update({
        schoolAdminId: obj.schoolAdminId,
      })
      .then(() => {
        toast.success("Contract added successfully");
        onComplete();
      })
      .catch((error) => {
        toast.warning(error);
      });
  };

export const getSchoolAdminData = (id) => (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .get()
    .then(async (query) => {
      dispatch({
        type: "GET_SCHOOL_ADMIN_DATA",
        payload: query.data(),
      });
    });
};

export const IsLoader = (val) => async (dispatch) => {
  dispatch({
    type: "SET_IS_LOADING",
    payload: val,
  });
};
